import { createSlice } from '@reduxjs/toolkit';

type InitialState = {
	isDarkTheme: boolean;
};

const initialState: InitialState = {
	isDarkTheme: localStorage.getItem('uiTheme') === 'dark',
};

const themeReducer = createSlice({
	name: 'theme',
	initialState,
	reducers: {
		setIsDarkTheme: (state, action) => {
			state.isDarkTheme = action.payload;
		},
	},
});

export const { setIsDarkTheme } = themeReducer.actions;
export default themeReducer;
